// TODO(BNCH-57692): Remove this file once ENABLE_SIGHTGLASS_RUNS_SEARCH is enabled everywhere
import React from 'react';
import {connect} from 'react-redux';

import {trackEvent} from 'analytics/Analytics';
import {ArchiveStatus} from 'archive/ArchiveConstants';
import {assert} from 'Asserts';
import {RESULTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {BenchlingState} from 'redux-stores/reduceApp';
import {BenchlingDispatch} from 'redux-stores/Store';
import {MODEL_NAMES} from 'results/ResultsNamingConstants';
import FiltersContainer from 'search/filters/FiltersContainer';
import {FilterKey, Operator, SingleValueFilterWithDefault} from 'search/SearchConstants';
import PlainSearchInput, {ClearType} from 'ui-library/PlainSearchInput';
import {InputChangeEvent} from 'util/Types';

import {AvailabilityStatus} from './RunsInboxModalConstants';
import {changeArchiveFilter, changeSearchFilter, changeStatusFilter} from './RunsInboxModalReduxActions';

interface ConnectedProps {
  searchFilter: string;
  statusFilter: AvailabilityStatus;
  archiveFilter: ArchiveStatus;
}

function mapStateToProps(state: BenchlingState): ConnectedProps {
  const {searchFilter, statusFilter, archiveFilter} = state.ui.results.runsInboxModal;
  return {
    searchFilter,
    statusFilter,
    archiveFilter,
  };
}

interface DispatchProps {
  onSearchFilterChange: (searchFilter: string) => void;
  onStatusFilterChange: (statusFilter: AvailabilityStatus) => void;
  onArchiveFilterChange: (archiveFilter: ArchiveStatus) => void;
}

function mapDispatchToProps(dispatch: BenchlingDispatch): DispatchProps {
  return {
    onSearchFilterChange: (searchFilter: string) => {
      dispatch(changeSearchFilter(searchFilter));
    },
    onStatusFilterChange: (statusFilter: AvailabilityStatus) => {
      dispatch(changeStatusFilter(statusFilter));
    },
    onArchiveFilterChange: (archiveFilter: ArchiveStatus) => {
      dispatch(changeArchiveFilter(archiveFilter));
    },
  };
}

export type RunsInboxFiltersProps = ConnectedProps & DispatchProps;
export class RunsInboxFilters extends React.PureComponent<RunsInboxFiltersProps> {
  _handleChangeFilters(filters: Array<SingleValueFilterWithDefault>): void {
    for (const filter of filters) {
      switch (filter.key) {
        case FilterKey.RUN_AVAILABILITY:
          this.props.onStatusFilterChange(filter.value as AvailabilityStatus);
          trackEvent(RESULTS_ANALYTICS_ACTIONS.CHANGED_RUNS_INBOX_IN_ENTRY_FILTER, {
            value: filter.value,
          });
          break;
        case FilterKey.ARCHIVE_STATUS:
          this.props.onArchiveFilterChange(filter.value as ArchiveStatus);
          trackEvent(RESULTS_ANALYTICS_ACTIONS.CHANGED_RUNS_INBOX_ARCHIVE_FILTER, {
            value: filter.value,
          });
          break;
        default:
          assert(false, `Unexpected filter key in RunsInboxFilters: ${filter.key}`);
      }
    }
  }

  override render(): JSX.Element {
    return (
      <div className="u-flex-display u-spacing-bottom">
        <PlainSearchInput
          className="u-small-spacing-right runsInboxModal-searchFilter"
          clearType={ClearType.X}
          onEscape={() => {
            this.props.onSearchFilterChange('');
          }}
          onChange={(e: InputChangeEvent) => {
            this.props.onSearchFilterChange(e.target.value);
          }}
          placeholder={`Search ${MODEL_NAMES.runs}`}
          value={this.props.searchFilter}
        />
        <FiltersContainer
          primaryFilterOptions={[
            {filterKey: FilterKey.RUN_AVAILABILITY},
            {filterKey: FilterKey.ARCHIVE_STATUS},
          ]}
          filters={[
            {key: FilterKey.ARCHIVE_STATUS, value: this.props.archiveFilter, operator: Operator.IS},
            {key: FilterKey.RUN_AVAILABILITY, value: this.props.statusFilter, operator: Operator.IS},
          ]}
          onChangeFilters={(filters: Array<SingleValueFilterWithDefault>) => {
            this._handleChangeFilters(filters);
          }}
          selectedSchema={null}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RunsInboxFilters);
